import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "pad10 llgreyBg rad20",
  style: {}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fs12 fw600 mb10 ml10" }, "検索する出席者を選択:", -1)
const _hoisted_3 = {
  key: 0,
  class: "w100"
}
const _hoisted_4 = {
  class: "posAb",
  style: {"width":"18px","top":"-5px","right":"-5px"}
}
const _hoisted_5 = ["src", "onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = {
  key: 1,
  class: "w100"
}
const _hoisted_8 = {
  class: "centered mt10",
  style: {}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "dgrey" }, "検索する調整ページの出席者を下記より選択してください", -1)
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "ofs w100 noscroll mt10",
  style: {"height":"300px"}
}
const _hoisted_13 = {
  class: "w100 centering",
  style: {"bottom":"0"}
}
const _hoisted_14 = {
  class: "posAb w40 centered",
  style: {"left":"0","bottom":"0"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 fw400" }, "キャンセル", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  class: "posAb w60 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "fs14 whiteColor fw600",
  style: {"padding-top":"15px"}
}, "このメンバーを含む調整ページを検索", -1)
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_AddressBookContent = _resolveComponent("AddressBookContent")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "SearchBoxModal",
    "content-class": "modalContent shadowContent pad15 rad10 ModalNormal",
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.Util.isPresent(_ctx.members))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.members, (mem, memindex) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "fl ml10 posRe mb10",
                  key: memindex
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
                      width: "18",
                      height: "18",
                      class: "fr pointer",
                      onClick: ($event: any) => (_ctx.deleteUser(mem))
                    }, null, 8, _hoisted_5)
                  ]),
                  _createVNode(_component_UserIcon, {
                    member: mem,
                    width: 45,
                    canEdit: false,
                    updateSelf: false,
                    showTooltip: true,
                    class: "pointer"
                  }, null, 8, ["member"])
                ]))
              }), 128)),
              _hoisted_6
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                  width: "36",
                  height: "36"
                }, null, 8, _hoisted_10)
              ]),
              _hoisted_11
            ]))
      ]),
      (_ctx.rm.userInfo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_AddressBookContent, {
              style: ``,
              class: _normalizeClass(``),
              members: _ctx.members,
              currentMember: _ctx.currentMember,
              editOrNewForm: false,
              showEditButton: false,
              showNewButton: false,
              hideGroups: true,
              focusSearchField: true,
              onAddAttendee: _ctx.addAttendee
            }, null, 8, ["members", "currentMember", "onAddAttendee"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("section", {
            class: "llgreyBg dgrey fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickCancel && _ctx.clickCancel(...args)))
          }, _hoisted_16)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("section", {
            class: "w100 skyblueBg fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickSearch && _ctx.clickSearch(...args)))
          }, _hoisted_19)
        ])
      ])
    ]),
    _: 1
  }, 8, ["onBeforeOpen"]))
}